import {Provider} from '@oilstone/container';
import {createApp, defineAsyncComponent} from "vue";
import App from '@/App.vue';
import Currency from "@/utilities/number/currency";
import StringFormatter from "@/utilities/string/formatter";
import NumberFormatter from "@/utilities/number/formatter";
import DateFormatter from "@/utilities/date/formatter";
import KeyValue from "@/services/lookup/key-value";
import VueGtag from "vue-gtag-next";

export default new Provider().boot(container => {
    const store = container.resolve('vuexStore');
    const router = container.resolve('router');
    const gtm = container.resolve('gtm');
    const resourceRegistry = container.resolve('resourceRegistry');
    const moduleRegistry = container.resolve('moduleRegistry');
    const registered = [];

    const autoload = [
        require.context('../shared/assets/logos', true, /\.vue$/),
        require.context('../shared/base', true, /\.vue$/),
        require.context('../shared/layout', true, /\.vue$/),
        require.context('../shared/ui', true, /\.vue$/),
        require.context('../shared/modules/ui', true, /\.vue$/),
        require.context('../services/resources/ui', true, /\.vue$/),
        require.context('../services/navigation/ui', true, /\.vue$/),
        require.context('../services/lookup/ui', true, /\.vue$/),
        require.context('../apps/cms/forms', true, /\.vue$/),
        require.context('../apps/cms/layout', true, /\.vue$/),
    ];

    const app = createApp(App).use(router).use(store).use(VueGtag, {
        property: { id: "G-QESTHT2KX8" },
        isEnabled: false,
        // useDebugger: true,
    });

    if (gtm) {
        app.use(gtm);
    }

    autoload.forEach(context => {
        context.keys().forEach((filename) => {
            const componentConfig = context(filename);
            const componentName = filename.split('/').pop().replace(/\.\w+$/, '');

            if (!registered.includes(componentName)) {
                app.component(componentName, componentConfig.default || componentConfig)
            }

            registered.push(componentName);
        });
    });

    moduleRegistry.all().forEach(resource => {
        for (let component in resource.config.components) {
            const componentConfig = resource.config.components[component];

            if (!registered.includes(componentConfig.name)) {
                app.component(componentConfig.name, defineAsyncComponent(componentConfig.loader));
            }

            registered.push(componentConfig.name);
        }
    });

    resourceRegistry.all().forEach(resource => {
        for (let component in resource.config.components) {
            const componentConfig = resource.config.components[component];

            if (!registered.includes(componentConfig.name)) {
                app.component(componentConfig.name, defineAsyncComponent(componentConfig.loader));
            }

            if (resource.config.components.webRecord && resource.config.components.webRecord.templates) {
                for (let template in resource.config.components.webRecord.templates) {
                    const templateComponentConfig = resource.config.components.webRecord.templates[template].component;

                    if (!registered.includes(templateComponentConfig.name)) {
                        app.component(templateComponentConfig.name, defineAsyncComponent(templateComponentConfig.loader));
                    }

                    registered.push(templateComponentConfig.name);
                }
            }

            registered.push(componentConfig.name);
        }
    });

    app.config.globalProperties.$filters = {
        currency: Currency,
        string: StringFormatter,
        number: NumberFormatter,
        date: DateFormatter,
        keyValue: KeyValue,
    };

    const vue = app.mount('#app');

    container.add('vue', vue);
});
